export default __webpack_public_path__ + "static/media/img45.8fc8756d.jpg";